<template>
  <v-flex>
    <v-card class="elevation-0 pa-5" flat>
        <h1 class="fonte text-uppercase ">Filtro de mensagens</h1>
            <v-layout row wrap grid pt-3>
              <v-flex xs12 sm6 md6 pr-3>
                <span class="caption">Data Inicial</span>
                <datetime
                  type="datetime"
                  class="subheading"
                  v-model="filtro.dataInicial"
                  :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                  format="dd/MM/yyyy HH:mm"
                ></datetime>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <span class="caption font-weight-regular">Data Final</span>
                <datetime
                  type="datetime"
                  class="subheading"
                  v-model="filtro.dataFinal"
                  :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                  format="dd/MM/yyyy HH:mm"
                ></datetime>
              </v-flex>
              <v-flex xs12 sm6 md6 pr-3 pt-3>
                <v-text-field
                  label="Número que foi enviado"
                  color="teal"
                  placeholder="Insira o número"
                  v-model="filtro.phone"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pt-3>
                <v-text-field
                  label="Texto do sms"
                  color="teal"
                  placeholder="Insira o texto"
                  v-model="filtro.text"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12>
              <v-select
                v-model="filtro.status"
                :items="getAllStatusSms()"
                color="teal"
                item-text="descricao"
                item-value="status"
                label="Filtro por status"
                placeholder="Selecione o status"
                multiple
                chips
                persistent-hint
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-btn
                :loading="isLoadingBusca"
                :disabled="isLoadingBusca"
                color="fundo"
                @click="filtro.page=1, getSms()"
                block
                large
                round
              >
                <v-icon left >search</v-icon> Pesquisar
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </template>
              </v-btn>
            </v-flex>
          </v-layout>
    </v-card>
    <v-divider></v-divider>
    <v-card flat class="mb-3 pb-3">
      <h1 class="fonte text-uppercase ml-5 mt-3">Mensagens</h1>
      <v-data-table
        :headers="headers"
        :items="ultimas"
        hide-actions="hide-actions"
        :loading="isLoadingBusca"
        class="pt-3"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.phone }}</td>
          <td class="text-xs-center">{{ props.item.text }}</td>
          <td class="text-xs-center">{{ convertDataBR(props.item.created) }}</td>
          <td class="text-xs-center">

            <v-badge
              v-if="props.item.status == 208 && props.item.response && props.item.response.length > 0"
                overlap
            >
              <template v-slot:badge>
                {{ props.item.response.length }}
              </template>
              <v-btn
                :color="status(props.item.status).type"
                text-color="white"
                round
                @click="showDialogResponses(props.item)"
              >
                {{ status(props.item.status).status }}
              </v-btn>
            </v-badge>
            <v-chip
              :color="status(props.item.status).type"
              text-color="white"
              v-else
            >
              {{ status(props.item.status).status }}
            </v-chip>
          </td>
        </template>
        <v-alert
        slot="no-results" :value="true" color="error" icon="warning"> Sua busca por &quot;{{ search }}&quot; não retornou resultados.</v-alert>
      </v-data-table>
      <div class="text-xs-center mb-1 pb-1">
        <v-btn fab dark small color="fundo" :disabled="disabledLeft" @click="arrow()">
          <v-icon dark>chevron_left</v-icon>
        </v-btn>
        <v-chip>{{ filtro.page }}</v-chip>
        <v-btn fab dark small color="fundo" :disabled="disabledRight" @click="next()">
          <v-icon dark>chevron_right</v-icon>
        </v-btn>
      </div>
  </v-card>


  <v-dialog
      v-model="dialogResponses"
      max-width="800"
    >
      <v-card v-if="Object.keys(smsSelected).length > 0">
        <v-card-title class="headline">Respostas do número {{ smsSelected.phone }}</v-card-title>
        <v-data-table
            :headers="headersSmsSelected"
            :items="smsSelected.response"
            hide-actions
          >
          <template v-slot:items="props">
            <td class="text-xs-center">{{ smsSelected.phone }}</td>
            <td class="text-xs-center">{{ props.item.message }}</td>
            <td class="text-xs-center">{{ convertDataBR(props.item.date) }}</td>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialogResponses = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-flex>
</template>


<script>
  import {mapActions} from 'vuex'
  import moment from 'moment-timezone'
  import * as helpers from './../../../helpers/helpers'

  export default {
    data () {
      return {
        calendar1: false,
        calendar2: false,
        isLoadingBusca: true,
        disabledRight: false,
        dialogResponses: false,
        smsSelected: {},
        filtro:{
          dataInicial: moment(new Date()).format('YYYY-MM-DD') + 'T00:00',
          dataFinal:moment(new Date()).format('YYYY-MM-DD') + 'T23:59',
          hoje: moment(new Date()).format('YYYY-MM-DD'),
          phone: '',
          text: '',
          status: '',
          page: 1
        },
        search: '',
        headers: [
          { text: 'Envio', value: 'envio', align:'center', sortable: false },
          { text: 'Telefone', value: 'telefone', align:'center', sortable: false},
          { text: 'Mensagem', value: 'mensagem', align:'center', sortable: false },
          { text: 'Data de criação', value: 'datacriacao', align:'center', sortable: false },
          { text: 'Status', value: 'status', align:'center', sortable: false }
        ],
        headersSmsSelected: [
          { text: 'Telefone', value: 'telefone', align:'center' },
          { text: 'Mensagem', value: 'mensagem', align:'center' },
          { text: 'Data de criação', value: 'datacriacao', align:'center' }
        ]
      }
    },
    computed:{
      formatDateInicial()
      {
        if (!this.filtro.dataInicial) return null
        const [year, month, day] = this.filtro.dataInicial.split('-')
        return `${day}/${month}/${year}`
      },
      formatDateFinal()
      {
        if (!this.filtro.dataFinal) return null
        const [year, month, day] = this.filtro.dataFinal.split('-')
        return `${day}/${month}/${year}`
      },
      ultimas ()
      {
        return this.$store.getters.getUltimasMensagens
      },
      disabledLeft ()
      {
        if(this.filtro.page == 1) {
          return true
        }
      }
    },
    methods: {
      ...mapActions(['getUltimosSms']),

      showDialogResponses (sms) {
        this.smsSelected = sms
        this.dialogResponses = true
      },
      convertDataBR (data) {
        return helpers.getDateTimeZoneBR(data)
      },
      convertDataEUA(data) {
        return moment(data).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
      },
      status (status) {
        return helpers.getStatusSms(status)
      },
      getAllStatusSms () {
        return helpers.getAllStatusSms()
      },
      async next(){
        this.filtro.page++
        let status = await this.getSms(true)
        if(!status) {
          this.filtro.page--
          this.isLoadingBusca = false
          this.$eventHub.emit('snackBar', { message: 'Não tem dados na próxima página' })
        }
      },
      async arrow () {
        this.filtro.page--
        await this.getSms(true)
      },
      async getSms (pagination = false) {
        this.isLoadingBusca      = true
        this.filtro.isPagination = pagination
        let resp = await this.getUltimosSms(this.filtro, pagination)
        this.isLoadingBusca = false
        return resp
      }
    },
    async mounted () {
      this.getSms()
    }

  }
</script>


<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/user/mensagens/ListarMensagens.vue